/**
 * Meta Pixel Utility
 * Safely wraps fbq calls and provides typed eCommerce events
 */

// Define fbq type on window to prevent TS errors
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

export const pixel = {
  /**
   * Track standard PageView event
   */
  pageView: () => {
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", "PageView");
    }
  },

  /**
   * Track ViewContent event (when user views a product)
   */
  viewContent: (data: {
    content_ids: string[];
    content_name: string;
    content_type: string;
    content_category?: string;
    value: number;
    currency: string;
  }) => {
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", "ViewContent", data);
    }
  },

  /**
   * Track AddToCart event
   */
  addToCart: (data: {
    content_ids: string[];
    content_name: string;
    content_type: string;
    value: number;
    currency: string;
  }) => {
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", "AddToCart", data);
    }
  },

  /**
   * Track Purchase event.
   * Pass eventID = order external_reference so Meta can deduplicate
   * this browser event against the server-side CAPI Purchase event.
   */
  purchase: (data: {
    content_ids?: string[];
    value: number;
    currency: string;
    order_id?: string;
    eventID?: string;
  }) => {
    if (typeof window !== "undefined" && window.fbq) {
      const { eventID, ...eventData } = data;
      window.fbq(
        "track",
        "Purchase",
        eventData,
        eventID ? { eventID } : undefined,
      );
    }
  },

  /**
   * Track InitiateCheckout event (fired when user reaches the Review step)
   */
  initiateCheckout: (data: {
    value: number;
    currency: string;
    num_items?: number;
  }) => {
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", "InitiateCheckout", data);
    }
  },
};
